import React, { useState, useEffect } from "react";
import { Col, Row, Button, Form, Alert } from "react-bootstrap";
import { accountActionCreators } from '../store/AccountStore';
import { AppState } from '../store/configureStore';
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { CheckWrapper } from "./CheckWrapper";
import { PaymentAccountDropDwon } from "./PaymentAccountDropDown";
import { driverPay_source } from '../DCR.dtos';
import { hasPermission } from "../functions/hasPermission";
import { Permissions } from '../store/HelperStore';
import { MessagePopup, MessageTypes } from "./MessagePopup";
import Skeleton from "react-loading-skeleton";
import { historyActionCreators } from '../store/HistoryStore';


export interface UpdateContributionOptionsProps {
    showUpdateContributionOption: boolean;
    onClose: any;
    orgType?: string;
    selectedScheduleType?: string;
    selectedAccontSequece?: string;
    paymentAccounts?: driverPay_source[];
}

export type TUpdateContributionOptionsComponent = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const UpdateContributionOptionsComponent = function (props: TUpdateContributionOptionsComponent) {

    const [isGenerateFile, setIsGenerateFile] = useState(false);
    const [autoFundingOption, setAutoFundingOption] = useState(props.ownProps.selectedScheduleType || "");

    const [enableSubmit, setEnableSubmit] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const isEBiller = (props.ownProps.orgType?.toUpperCase() === "E");
    const updateContributionClaim = hasPermission(Permissions.UpdateContributions_Submit, props.currentUser.permissions);
    const selectedPaymentAccount = props.ownProps.selectedAccontSequece !== undefined ? props.ownProps.selectedAccontSequece : "-1";

    const [selectedAccountSequence, setSelectedAccountSequence] = useState(selectedPaymentAccount !== "-1" ? selectedPaymentAccount : "");
    const [executeDDLChange, setExecuteDDLChange] = useState(false);

    const handleFundingOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAutoFundingOption(e.target.value);
    }

    const handleAccountDropDwonChnage = (selectedAccount: driverPay_source) => {
        if (executeDDLChange) {
            if (selectedAccount !== undefined) {
                setSelectedAccountSequence(selectedAccount.sequence.toString());
            }
            else {
                setSelectedAccountSequence("");
            }
        }
        else {
            setExecuteDDLChange(true);
        }
    }

    useEffect(() => {
        if (props.accounts.isContribOptionUpdated) {
            if (!props.accounts.isUpdateContributionError) {
                setShowSuccessPopup(true);
            }
        }
    }, [props.accounts.isContribOptionUpdated]);

    useEffect(() => {
        if (isGenerateFile) {
            setEnableSubmit(updateContributionClaim);
        }
        if (autoFundingOption === "auto") {
            setEnableSubmit((selectedAccountSequence.trim().length > 0) && updateContributionClaim);
        }
        else {
            setEnableSubmit(updateContributionClaim);
        }
    }, [isGenerateFile, autoFundingOption, selectedAccountSequence])

    const getFileType = (): string => {
        if (props.ownProps.orgType?.toUpperCase() === "P") {
            return "payroll";
        }
        else if (isGenerateFile) {
            return "upload";
        }
        else {
            return "ebill";
        }
    }

    const submitClick = () => {
        const activeInstitution = props.dcr.selectedInstitution;
        const scheduleType = (!isGenerateFile ? autoFundingOption : "");
        const userName = props.currentUser.userName;
        const accountSequence = ((scheduleType.length > 0 && autoFundingOption === "auto") ? selectedAccountSequence?.padStart(3, "0") : "");
        const filetype = getFileType();
        props.updateContributionOptions(activeInstitution, scheduleType, accountSequence, filetype, userName);
    }

    const successOkClick = () => {
        props.fetchCMHistory(props.dcr?.selectedInstitution, false, false);
        props.resetAllStateAndRedirect();
    }

    return (
        <>
            <Row className="tbl-info-wrap">
                <Col className="float-left">
                    <h4>Update Contribution Options</h4>
                </Col>
            </Row>
            {(props.accounts.isUpdateContributionError && props.accounts.isContribOptionUpdated) &&
                <Row>
                    <Col>
                        < Alert className="mt-2" variant="danger">{props.accounts?.updateAccountErrorMessage}</Alert>
                    </Col>
                </Row>
            }

            {isEBiller &&
                <>
                    <Row>
                        <Col className="text-muted float-left">
                            <div>File Generation</div>
                        </Col>
                    </Row>
                    <Row className="mt-1">
                        <Col>
                            <ul>
                                <li>
                                    Active Management – Continue to receive a bill and actively manage contribution and data updates each month. No action is needed from you to select this method.
                                </li>
                                <li>
                                    File Upload – Upload a file each month and independently manage monthly contributions. Under this option, Wespath will not generate a bill. Please contact Wespath at <strong>1-800-851-2201.</strong>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    <hr />
                </>
            }
            {(!isGenerateFile) &&
                <>
                    <Row>
                        <Col className="text-muted float-left">
                            <div>Funding Options</div>
                        </Col>
                    </Row>
                    <div>
                        <Row>
                            <Col className="col-12">
                                <CheckWrapper>
                                <Form.Check type="radio" name="_autoFundingGroup" id="_autoFundingGroup_auto" value="auto" onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleFundingOptionChange(e) }}
                                        custom checked={autoFundingOption?.toLowerCase() === "auto"} label="Automatic funding - Recurring payments will begin with your next contribution file. ACH funding will be initiated on the business day following the payroll date if your contribution file is sent by your payroll provider.  If your contribution file is generated by Wespath, ACH funding will be initated no earlier than three business days before the end of the month. Unpaid bills on your account will not be paid automatically; those payments must be scheduled manually." />
                                </CheckWrapper>
                            </Col>
                        </Row>
                        {(autoFundingOption.toLowerCase() === "auto") &&
                            <Row>
                                <Col className="ml-2">
                                    <PaymentAccountDropDwon onChange={(selectedAccount: driverPay_source) => { handleAccountDropDwonChnage(selectedAccount) }} defaultValue={selectedAccountSequence} />
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col className="col-12">
                                <CheckWrapper>
                                <Form.Check type="radio" name="_autoFundingGroup" id="_autoFundingGroup_manual" value="manual" onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleFundingOptionChange(e) }}
                                        custom checked={autoFundingOption?.toLowerCase() === "manual"} label="Manually scheduled funding - You must manually schedule payment for any unpaid files and all subsequent payments unless you change your election to automatic funding." />
                                </CheckWrapper>
                            </Col>
                        </Row>
                    </div>

                </>
            }
            {!props.accounts.isContribOptionUpdating &&
                <Row className="text-center m-2">
                    <Col className="col-12 col-sm-2 col-md-4 col-lg-8 d-none d-sm-block"></Col>
                    <Col className="col-12 col-sm-5 col-md-4 col-lg-2">
                        <Button type="button" variant="secondary" className="btn-block mr-sm-2 mb-2" onClick={() => { props.ownProps.onClose(); }}>Cancel</Button>
                    </Col>
                    <Col className="col-12 col-sm-5 col-md-4 col-lg-2">
                        <Button type="button" className="btn-block" disabled={(!enableSubmit)} onClick={() => { submitClick() }}>Submit</Button>
                    </Col>
                </Row>
            }

            {props.accounts.isContribOptionUpdating &&
                <LoadingSkeletonButtonBar />
            }

            {showSuccessPopup &&
                <MessagePopup showPopup={showSuccessPopup} popupTitle={"Contribution Management"} messageType={MessageTypes.Success} okButtonText={"Ok"} onOkClick={() => { successOkClick() }}>
                {"You have successfully updated your organization's contribution options. You will receive a confirmation via e-mail."}
                </MessagePopup>
            }

        </>

    )
}

const LoadingSkeletonButtonBar = () => (
    <>
        <Row className="my-1 pt-2 d-flex justify-content-center">
            <div><Skeleton width={'33em'} /></div>
            <div><Skeleton width={'33em'} /></div>
        </Row>
        <Row className="d-flex justify-content-center">
            <div><Skeleton width={'33em'} /></div>
            <div><Skeleton width={'33em'} /></div>
        </Row>
    </>
);

function mapStateToProps(state: AppState, updateContributionOptionsProps: UpdateContributionOptionsProps) {
    return {
        dcr: state.dcr,
        currentUser: state.dcr.currentuserInfo?.user,
        accounts: state.accounts,
        ownProps: updateContributionOptionsProps
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...accountActionCreators, ...historyActionCreators }, dispatch);
}

export const UpdateContributionOptions = connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateContributionOptionsComponent);
